import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Box, CircularProgress } from '@mui/material';



//todo: there are two issue first is like start date is alway a month different what i set in the filter



import FeedbackFilter from '../components/FeedbackFilter';
import SearchHistory from '../components/SearchHistory';

import { useFeedbackFilter } from '../hooks/useFeedbackFilter';
import { useFeedBackHandler } from '../hooks/useFeedbackHandler';
import { useApplyFeedbackFilters } from '../hooks/useApplyFeebackFilter';
import { useApiData } from '../hooks/useApiData';
import { useStateData } from '../hooks/useStateData';
import { useSearchHistory } from '../hooks/useSearchHistory';
import { useHistoryHandler } from '../hooks/useHistoryHandler';
import CategoryBarChart from '../components/CategoryBarChart';
import FeedbackComponent from '../components/FeedbackComponent';
import api from '../utils/apiInterceptor';
import { API_URL } from '../constants/data';

const SimpleLoadingOverlay = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(1px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <CircularProgress size={36} thickness={4} />
    </Box>
  );
};


const FeedbackPage = () => {

  const [categories, setCategories] = useState({});
  const [complaintsCount, setComplaintsCount] = useState()
  const [feedbackStats, setFeedbackStats] = useState({})
  const [feedbackData, setFeedbackData] = useState([]); // Store raw feedback data
  const [totalComplaints, setTotalComplaints] = useState(0);
  const [distributionData, setDistributionData] = useState({
    Sector: null,
    SectorCount: 0,
    CompanyCount: 0,
    CategoryCount: 0,
    userexperienceCount: 0,
    CompanyName: null,
    Category: null,
    userexperience: null,
    SectorComplaintsCount: 0,
    CompanyComplaintsCount: 0,
    CategoryComplaintsCount: 0,
    userexperienceComplaintsCount: 0,
  });
  const [loading, setLoading] = useState({
    Sector: false,
    CompanyName: false,
    Category: false,
    userexperience: false
  });

  // Error state
  const [errors, setErrors] = useState({
    Sector: null,
    CompanyName: null,
    Category: null,
    userexperience: null
  });

  // Keyword data state
  const [keywordData, setKeywordData] = useState(null);
  const [keywordLoading, setKeywordLoading] = useState(false);



  const { defaultStateData } = useStateData();
  const { filters, handleFeedbackFilterChange, updateFeedbackFilter } = useFeedbackFilter();

  const { searchHistory, saveToHistory, clearHistory, deleteHistoryItem } = useSearchHistory();
  const {
    totalCounts,
    setTotalCounts,
    isLoading,
    setIsLoading,
    fetchSemanticRCA,
    fetchUserData,
    fetchSpatialData,
    stateData,
    setStateData,
    fetchSectorDistribution,
    fetchMultipleDistributions,
    fetchFeedbackStats,
    fetchFeedbackKeyWords,
  } = useApiData(defaultStateData);

  const [dividerPos, setDividerPos] = useState(55);
  const containerRef = useRef(null);
  const isDragging = useRef(false);
  const [pbReady, setPbReady] = useState(false);

  const handleChartReady = useCallback(() => {
    setPbReady(true);
  }, []);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    isDragging.current = true;
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
  }, []);

  const handleMouseUp = useCallback(() => {
    isDragging.current = false;
    document.body.style.userSelect = '';
    document.body.style.cursor = '';
  }, []);

  const handleMouseMove = useCallback((e) => {
    if (!isDragging.current || !containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const newPos = ((e.clientX - rect.left) / rect.width) * 100;
    const constrainedPos = Math.max(20, Math.min(80, newPos));
    setDividerPos(constrainedPos);
  }, []);

  useEffect(() => {
    const cleanup = () => {
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      isDragging.current = false;
    };

    const globalMouseUp = () => {
      if (isDragging.current) {
        handleMouseUp();
      }
    };

    document.addEventListener('mouseup', globalMouseUp);
    window.addEventListener('beforeunload', cleanup);

    return () => {
      document.removeEventListener('mouseup', globalMouseUp);
      window.removeEventListener('beforeunload', cleanup);
      cleanup();
    };
  }, [handleMouseUp]);

  const fetchFeedbackData = async (params) => {
    try {
      const filterParams = params || filters;
      const data = await fetchFeedbackStats(
        filterParams,
        setFeedbackStats
      )
      setComplaintsCount(data?.total_count)
      setFeedbackStats(data)

    } catch (error) {
      console.log(error)
    }
  }



  const { handleFeedbackClick } = useFeedBackHandler({
    filters,
    setIsLoading,
    handleFeedbackFilterChange,
    setDistributionData,
    fetchSemanticRCA,
    fetchSectorDistribution,
    fetchMultipleDistributions,
    setTotalComplaints,
    fetchFeedbackData,
    setLoading,
    setErrors,
    setFeedbackData,
    setFeedbackStats,
    fetchFeedbackStats,
    setComplaintsCount,
  })



  const { handleHistoryClick } = useHistoryHandler({
    filters,
    fetchSemanticRCA,
    fetchSpatialData,
    fetchSectorDistribution,
    fetchUserData,
    setTotalCounts,
    fetchMultipleDistributions,
    setIsLoading,
  });


  const { handleApplyFeedbackFilters } = useApplyFeedbackFilters({
    filters,
    fetchMultipleDistributions,
    setDistributionData,
    fetchSectorDistribution,
    fetchSemanticRCA,
    setLoading,
    setErrors,
    setFeedbackData,
    setFeedbackStats,
    setComplaintsCount,
    handleFeedbackFilterChange,
    fetchFeedbackStats,
  })


  const handleClearHistory = useCallback(() => {
    clearHistory();
    // updateFilters({ query: '' }); 
    setStateData([]);
  }, [clearHistory, setStateData]);

  useEffect(() => {
    setPbReady(false);
  }, [isLoading, loading, distributionData, filters.attribute]);

  useEffect(() => {
    let cancelled = false;

    const initialLoad = async () => {
      try {
        setIsLoading(true);

        // Step 1: Fetch Sector distribution
        const attributes = ['Sector'];
        const baseFilters = {
          startDate: filters.startDate,
          endDate: filters.endDate,
          Sector: 'All',
          CompanyName: 'All',
          Category: 'All',
          skip: 0,
          limit: 1000
        };

        await fetchMultipleDistributions(attributes, baseFilters, setDistributionData, setLoading, setErrors);

        // Step 2: Fetch feedback stats (ratings distribution)
        // Step 2: Fetch feedback stats (ratings distribution)
        const statsData = await fetchFeedbackStats(filters, setFeedbackStats);
        setComplaintsCount(statsData?.total_feedback_count || 0);

        if (cancelled) return;

        // Note: FeedbackComponent will fetch rating 5 (Excellent) on mount
        // No need to fetch all ratings here

        setIsLoading(false);
      } catch (error) {
        console.error('Error in initial load:', error);
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    initialLoad();

    return () => {
      cancelled = true;
    };
  }, []); // Only run on mount



  const isAnyLoading = isLoading || keywordLoading || Object.values(loading).some(l => l);
  const rightPanelLoading = (
    Boolean(isLoading) ||
    Boolean(keywordLoading) ||
    Boolean(loading?.CompanyName) ||
    Boolean(loading?.Category) ||
    Boolean(loading?.userexperience)
  );

  const currentAttributeData = (() => {
    const currentAttr = filters.attribute || 'Sector';
    const data = distributionData[currentAttr];
    const isCurrentlyLoading = loading[currentAttr];

    if (isCurrentlyLoading) {
      return undefined;
    }

    return data || [];
  })();

  const isProportionalBlocksLoading = Boolean(loading[filters.attribute || 'Sector']) || currentAttributeData === undefined;


  return (
    <>

      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%', overflow: 'auto' }}>
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#ECEAFC', px: { xs: 1.5, sm: 2, md: 2.5 }, pt: { xs: 1, sm: 1.5, lg: 0, xl: 0 }, pb: { xs: 0.5, sm: 1 }, flexShrink: 0 }}>
          {/* <SearchHistory
            searchHistory={searchHistory}
            onHistoryClick={handleHistoryClick}
            onClearHistory={handleClearHistory}
            onDeleteHistoryItem={deleteHistoryItem}
          /> */}
          <FeedbackFilter
            filters={filters}
            onFilterChange={handleFeedbackFilterChange}
            onApplyFilters={handleApplyFeedbackFilters}
            suggestionData={currentAttributeData}
            distributionData={distributionData}
            isLoading={isLoading}
            searchHistory={searchHistory}
            clearHistory={handleClearHistory}
          />
        </Box>

        <Box
          ref={containerRef}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            px: { xs: 1, sm: 2 },
            pt: { xs: 1, sm: 1 },
            pb: { xs: 1, sm: 2 },
            flex: 1,
            position: 'relative',
            overflow: 'visible',
            minHeight: 0,
            gap: { xs: 1.5, md: 0 }
          }}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <Box sx={{
            width: { xs: '100%', md: `${dividerPos}%` },
            minWidth: { md: '320px' },
            maxWidth: { md: '75%' },
            overflow: 'hidden',
            pr: { xs: 0, md: 1.5 },
            transition: isDragging.current ? 'none' : 'width 0.1s ease',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: { xs: 520, sm: 600 }
          }}>
            <CategoryBarChart
              Data={currentAttributeData}
              totalCounts={distributionData?.[`${filters?.attribute || 'Sector'}ComplaintsCount`] || 0}
              onDataPointClick={handleFeedbackClick}
              isLoading={isProportionalBlocksLoading}
              containerWidth={dividerPos}
              isFeedback={true}
              onReady={handleChartReady}
            />
          </Box>

          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              width: '8px',
              cursor: 'col-resize',
              backgroundColor: isDragging.current ? '#2196F3' : '#e0e0e0',
              borderRadius: '4px',
              mx: 0.75,
              position: 'relative',
              transition: isDragging.current ? 'none' : 'all 0.2s ease',
              boxShadow: isDragging.current ? '0 0 8px rgba(33, 150, 243, 0.3)' : 'none'
            }}
            onMouseDown={handleMouseDown}
            onMouseEnter={(e) => {
              if (!isDragging.current) {
                e.currentTarget.style.backgroundColor = '#bdbdbd';
              }
            }}
            onMouseLeave={(e) => {
              if (!isDragging.current) {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
              }
            }}
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '4px',
              height: '40px',
              backgroundColor: '#9e9e9e',
              borderRadius: '2px',
              opacity: 0.7
            }} />
          </Box>

          {/* Right Panel - FeedbackComponent */}
          <Box sx={{
            width: { xs: '100%', md: `${100 - dividerPos}%` },
            minWidth: { md: '320px' },
            overflow: 'visible',
            pl: { xs: 0, md: 1.5 },
            transition: isDragging.current ? 'none' : 'width 0.1s ease',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <FeedbackComponent
              totalCount={complaintsCount || 0}
              feedbackStats={feedbackStats}
              feedbackData={feedbackData}
              filters={filters}
              isLoading={rightPanelLoading}
            />
          </Box>
        </Box>

      </Box>
    </>
  )
}
export default FeedbackPage